type TranslationDictionary = { [key: string]: string };

export const categoryDictionary: TranslationDictionary = {
  FUEL: "Goriva",
  LUBRICANT: "Maziva",
  FILTER: "Filteri",
  REPLACEMENT_PART: "Rezervni delovi",
  TYRE: "Gume",
  SERVICE: "Usluge",
  OTHER: "Ostalo",
};

export const resourceCategoryDictionary: TranslationDictionary = {
  VEHICLE: "Vozilo",
  MECHANIZATION: "Radna mašina",
  MANUAL_MACHINE: "Ručna mašina",
  POWER_TOOL: "Električni alat",
  HAND_TOOL: "Ručni alat",
  ACCESSORY: "Dodatna oprema",
  OTHER: "Ostalo",
  PARTNERS: "Saradnici",
  LEASED: "Iznajmljeni resursi",
  IT_EQUIPMENT: "IT oprema",
  REAL_ESTATE: "Nekretnine",
};

export const resourceTypeDictionary: TranslationDictionary = {
  FIXED_ASSETS: "Osnovna sredstva",
  SMALL_INVENTORY: "Sitan inventar",
  PARTNERS: "Partneri",
};

export const salesUnitTypeDictionary: TranslationDictionary = {
  flat: "Stan",
  parking: "Parking",
  business_space: "Lokal",
  suite: "Apartman"
};

export const statusDictionary: TranslationDictionary = {
  ACTIVE: "Aktivan",
  INACTIVE: "Neaktivan",
};

export const resourceMaintenanceTypeDictionary: TranslationDictionary = {
  SERVICE: "Servis",
  REPAIR: "Popravka",
  REFUEL_LUBE: "Dopuna maziva"
};

export const inspectionTypeDictionary: TranslationDictionary = {
  REGISTRATION: "Registracija",
  TACHOGRAPH: "An. tahograf",
  DIGITAL_TACHOGRAPH: "Dig. tahograf",
  FIRE_EXTINGUISHER: "PP aparat",
  FIRST_AID_KIT: "Prva pomoć",
  TECHNICAL_INSPECTION: "6m tehnički",
  FULL_COVERAGE_INSURANCE: "Kasko",
};

export const alarmTypeDictionary: TranslationDictionary = {
  REGISTRATION: "registracije",
  TACHOGRAPH: "tahografa",
  FIRE_EXTINGUISHER: "pp aparata",
  FIRST_AID_KIT: "prve pomoći",
  TECHNICAL_INSPECTION: "6m tehničkog",
  FULL_COVERAGE_INSURANCE: "kaska",
  SERVICE_DAYS: "servisa",
  SERVICE_DISTANCE: "servisa"
};

export const monthNames = [
  "Januar",
  "Februar",
  "Mart",
  "April",
  "Maj",
  "Jun",
  "Jul",
  "Avgust",
  "Septembar",
  "Oktobar",
  "Novembar",
  "Decembar",
];
